import * as React from "react";
import MultiTag from "../multiTag";
// import MultiSelect from "widget/multiSelect2";
import { connect } from "react-redux";

interface IOrderStatus {
  // 数据源
  orderStatus: any;
  onChange: any;
  getOrderStatus: any;
  placehorder?: any;
  value?: any;
  onRef?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

// 订单状态 多选标签
class OrderStatus extends React.Component<IOrderStatus, any> {
  state = {
    multiTagCurrent: null
  };

  constructor(props: IOrderStatus) {
    super(props);
    this.props.onRef && this.props.onRef(this);
  }

  componentDidMount() {
    this.props.getOrderStatus();
  }

  shouldComponentUpdate(nextProps) {
    // 当value值由值变化为空时，清空组件的状态恢复到初始化状态
    if (
      this.props.value &&
      this.props.value.length > 0 &&
      (!nextProps.value || nextProps.value.length == 0)
    ) {
      console.log("我被清空了");
      this.clear();
    }
    return true;
  }

  // 获取多选标签的引用
  getRef = multiTagCurrent => {
    this.setState({
      multiTagCurrent
    });
  };

  // 清除选中的标签
  clear = () => {
    const multiTagCurrent: any = this.state.multiTagCurrent;
    if (multiTagCurrent) {
      //  multiTagCurrent.clear();
    }
  };

  render() {
    return (
      <MultiTag
        data={this.props.orderStatus}
        value={this.props.value}
        returnCheckedOption={this.props.onChange}
        placehorder={this.props.placehorder}
        onRef={this.getRef}
        containerBody={this.props.containerBody}
      />
    );
    // return <MultiSelect />;
  }
}

const mapState = state => ({
  orderStatus: state.share.orderStatus
});

const mapDispatch = dispatch => {
  return {
    getOrderStatus: dispatch.orderStatus.getOrderStatus
  };
};

export default connect(
  mapState,
  mapDispatch
)(OrderStatus);
